// ConfirmDropFollowersDialog.tsx — confirmation modal shown when the user
// flips Private ON while "Keep existing followers" is OFF: their current
// followers will be demoted to pending requests. Mirrors DeleteAccountDialog's
// shape (Dialog + Warn paragraph + Cancel/danger-action row).
import styled from 'styled-components';
import { Dialog, Button } from '@/ui';

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Warn = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textMuted};
`;

const Row = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;

export function ConfirmDropFollowersDialog({
  onConfirm,
  onClose,
}: {
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <Dialog open title="Turn on private account?" onClose={onClose}>
      <Stack>
        <Warn>
          Your &quot;Keep existing followers&quot; setting is off. Everyone who currently follows
          you will be moved to a pending follow request. They&apos;ll need to be approved again
          before they can see your posts.
        </Warn>
        <Row>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onConfirm}>
            Turn on and request re-follows
          </Button>
        </Row>
      </Stack>
    </Dialog>
  );
}
